// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history_backBtn_div{
    margin: 0 auto 30px;
    width: 80%;
    height: fit-content;
    border-bottom: 0.5px solid rgb(13, 65, 111);
}
.history_backBtn{
    margin: 20px auto 30px;
    width: 62.5%;
    height: 40px;
    font-size: 18px;
    font-weight: bold;
    background-color: rgb(13, 65, 111);
    color: white;
    border: none;
    cursor: pointer;
}
.history_backBtn:hover{
    background-color: white;
    color: rgb(13, 65, 111);
    border: 0.5px solid rgb(13, 65, 111);
    box-shadow: 2px 2px 4px grey;
}
.history_header{
    font-size: 45px;
    margin: auto;
}

/* calendar */
.calendar-container {
  width: 90%;
  max-width: 800px;
  margin: 30px auto;
  font-family: Arial, sans-serif;
  padding: 30px 5%;
  background-color: rgb(160, 204, 242);
  border-radius: 30px;
  color: rgb(13, 65, 111);
}

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.calendar-title {
  font-size: 2rem;
  font-weight: bold;
}

.calendar-btn_prev, .calendar-btn_next {
  background-color: rgb(13, 65, 111);
  color: white;
  border-radius: 5px;
  padding: 4px 30px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.calendar-btn_prev:hover, .calendar-btn_next:hover {
  background-color: #f2f2f2;
  background-color: white;
  color: rgb(13, 65, 111);
  border: 0.5px solid rgb(13, 65, 111);
}
.calendar-btn_next:hover{
    translate: -5px 0;
}
.calendar-btn_prev:hover{
    translate: 5px 0;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
}

.calendar-day-header {
  text-align: center;
  font-weight: bold;
  padding: 8px 0;
  border-bottom: 2px solid rgb(13, 65, 111);
}

.calendar-day {
  border: 1px solid rgb(13, 65, 111);
  min-height: 80px;
  border-radius: 6px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: background-color 0.3s;
}

.calendar-day.empty {
  background-color: transparent;
  border: none;
}

.calendar-day-number {
  font-weight: bold;
  text-align: right;
  font-size: 0.9rem;
}

.calendar-day.active {
  background-color: #eaf6ff;
  border-color: #a5d8ff;
}

.calendar-day-content {
  font-size: 0.75rem;
  color: #333;
  text-align: left;
  margin-top: 4px;
}

.calendar-day.active:hover {
  background-color: #d6ecff;
}

.calendar-task {
  margin: 4px 0;
  padding-left: 4px;
  border-left: 3px solid transparent;
}

.task-done {
  color: #2e7d32;
  border-color: #2e7d32;
}

.task-pending {
  color: #c62828;
  border-color: #c62828;
}
`, "",{"version":3,"sources":["webpack://./src/components/style/history.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,2CAA2C;AAC/C;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,aAAa;AACb;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;AACtC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".history_backBtn_div{\n    margin: 0 auto 30px;\n    width: 80%;\n    height: fit-content;\n    border-bottom: 0.5px solid rgb(13, 65, 111);\n}\n.history_backBtn{\n    margin: 20px auto 30px;\n    width: 62.5%;\n    height: 40px;\n    font-size: 18px;\n    font-weight: bold;\n    background-color: rgb(13, 65, 111);\n    color: white;\n    border: none;\n    cursor: pointer;\n}\n.history_backBtn:hover{\n    background-color: white;\n    color: rgb(13, 65, 111);\n    border: 0.5px solid rgb(13, 65, 111);\n    box-shadow: 2px 2px 4px grey;\n}\n.history_header{\n    font-size: 45px;\n    margin: auto;\n}\n\n/* calendar */\n.calendar-container {\n  width: 90%;\n  max-width: 800px;\n  margin: 30px auto;\n  font-family: Arial, sans-serif;\n  padding: 30px 5%;\n  background-color: rgb(160, 204, 242);\n  border-radius: 30px;\n  color: rgb(13, 65, 111);\n}\n\n.calendar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.calendar-title {\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.calendar-btn_prev, .calendar-btn_next {\n  background-color: rgb(13, 65, 111);\n  color: white;\n  border-radius: 5px;\n  padding: 4px 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.calendar-btn_prev:hover, .calendar-btn_next:hover {\n  background-color: #f2f2f2;\n  background-color: white;\n  color: rgb(13, 65, 111);\n  border: 0.5px solid rgb(13, 65, 111);\n}\n.calendar-btn_next:hover{\n    translate: -5px 0;\n}\n.calendar-btn_prev:hover{\n    translate: 5px 0;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 6px;\n}\n\n.calendar-day-header {\n  text-align: center;\n  font-weight: bold;\n  padding: 8px 0;\n  border-bottom: 2px solid rgb(13, 65, 111);\n}\n\n.calendar-day {\n  border: 1px solid rgb(13, 65, 111);\n  min-height: 80px;\n  border-radius: 6px;\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: background-color 0.3s;\n}\n\n.calendar-day.empty {\n  background-color: transparent;\n  border: none;\n}\n\n.calendar-day-number {\n  font-weight: bold;\n  text-align: right;\n  font-size: 0.9rem;\n}\n\n.calendar-day.active {\n  background-color: #eaf6ff;\n  border-color: #a5d8ff;\n}\n\n.calendar-day-content {\n  font-size: 0.75rem;\n  color: #333;\n  text-align: left;\n  margin-top: 4px;\n}\n\n.calendar-day.active:hover {\n  background-color: #d6ecff;\n}\n\n.calendar-task {\n  margin: 4px 0;\n  padding-left: 4px;\n  border-left: 3px solid transparent;\n}\n\n.task-done {\n  color: #2e7d32;\n  border-color: #2e7d32;\n}\n\n.task-pending {\n  color: #c62828;\n  border-color: #c62828;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
